<template>
  <div class="Shop">
    <Header/>
    <div class="content">
      <div class="current-loc">
        <span>{{ $t('satellite.CurrentPosition') }}：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('satellite.Home') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('header.PersonalCenter') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('Order.ShoppingCart') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <p class="title">{{ $t('Order.ShoppingCart') }}</p>
      <hr style="background:white">
      <div class="query">
        <el-form ref="queryForm" :model="queryForm" style="display:flex;align-items:center">
          <el-form-item prop="productName" :label="$t('DataSubmission.ProductName') + ':'" size="mini"
                        class="query-item">
            <el-input v-model="queryForm.productName"></el-input>
          </el-form-item>
          <el-form-item prop="fileName" :label="$t('Order.filename') + ':'" size="mini" class="query-item">
            <el-input v-model="queryForm.fileName"></el-input>
          </el-form-item>
          <el-form-item prop="carType" :label="$t('product.DataType') + ':'" size="mini" class="query-item">
            <el-select :placeholder="$t('services.Pleaseselect')" v-model="queryForm.carType" @change="changeCarType">
              <el-option :label="i.dicItemName" :value="i.pkid" v-for="i in orderType" :key="i.index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="date" :label="$t('Order.Productiontime') + ':'" class="query-item"
                        style="margin-top:6px;">
            <el-date-picker
                v-model="queryForm.date"
                size="mini"
                type="daterange"
                range-separator="-"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('satellite.Start')"
                :end-placeholder="$t('satellite.End')">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="queryData">{{ $t('satellite.Search') }}</el-button>
            <el-button size="mini" @click="resetQuery">{{ $t('satellite.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="data-table">
        <el-table
            v-loading="showLoading"
            :element-loading-text="$t('Order.Ordergenerationinprogress')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.6)"
            :empty-text="$t('Intelligent.NoData')"
            class="changeSkin"
            :header-cell-style="header_cell_style_bd"
            :cell-style="cell_style_bd"
            :style="cell_style_bd"
            :data="tableData"
            border
            @selection-change="selectionChange"
            ref="multipleTable"
            style="width: 100%;">
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column
              :label="$t('Order.thumbnail')"
              align="center"
              width="180">
            <template slot-scope="scope">
              <img :src="scope.row.mediaUrl" v-if="scope.row.carTypeName==='卫星数据'||scope.row.carTypeName==='satelite'"
                   alt=""
                   style="width:24px;height:24px;">
            </template>
          </el-table-column>
          <el-table-column
              prop="productName"
              :label="$t('Order.Productname')"
              :show-overflow-tooltip="true"
              align="center"
              width="180">
          </el-table-column>
          <el-table-column
              prop="productFileName"
              :label="$t('Order.filename')"
              :show-overflow-tooltip="true"
              align="center">
          </el-table-column>
          <el-table-column
              prop="carTypeName"
              :label="$t('Order.datatype')"
              :show-overflow-tooltip="true"
              align="center">
          </el-table-column>
          <el-table-column
              prop="fileSuffix"
              :label="$t('Order.fileformat')"
              align="center">
          </el-table-column>
          <el-table-column
              :label="$t('Order.filesize')"
              align="center">
            <template slot-scope="scope">
              <span>{{ byte2Auto(scope.row.fileSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="createTime"
              :label="$t('Order.Jointime')"
              align="center">
          </el-table-column>
          <el-table-column :label="$t('Order.operation')"
                           align="center">
            <template slot-scope="scope">
              <span class="delete-detail" @click="deleteThis(scope.row.pkid)">{{ $t('DataSubmission.Delete') }}</span>
              <span class="delete-detail" @click="viewDetail(scope.row)">{{ $t('satellite.Details') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation">
        <div class="pagenation-left">
          <div class="select-nums">
            <svg t="1637715412245" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 p-id="1374" width="16" height="16">
              <path
                  d="M512 0C229.23 0 0 229.23 0 512s229.23 512 512 512 512-229.23 512-512S794.77 0 512 0z m44 256v339.492c0 24.301-19.7 44-44 44s-44-19.699-44-44V256c0-24.3 19.7-44 44-44s44 19.7 44 44z m-44 428c35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64z"
                  p-id="1375" fill="#1296db"></path>
            </svg>
            {{ $t('Order.Selected') }}:<span class="nums">{{ hadSelectRow.length }}</span>
            <span class="totals">{{ $t('Order.Totaldatasize') }}：{{ returnAll }}</span>
          </div>
          <el-button type="primary" size="medium" @click="putAllToOrder()">{{
              $t('Order.Oneclickordergeneration')
            }}
          </el-button>
          <el-button type="primary" size="medium" @click="createOrder()">{{ $t('Order.Generateorder') }}</el-button>
          <el-button size="medium" @click="clearSelect">{{ $t('Order.Deleteselecteddata') }}</el-button>
          <el-button size="medium" @click="clearShopCar">{{ $t('Order.clearcart') }}</el-button>
        </div>
        <el-pagination
            background
            :pager-count="7"
            :page-size="20"
            @current-change="currentChange"
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <Footer/>
    <el-dialog
        :title="$t('Order.Satellitedatadetails')"
        :custom-class="themeStatis==='theme1'?'dialog-new-bg-b basic-info-detail':'dialog-new-bg-w basic-info-detail'"
        :visible.sync="satelliteOrderDetail"
        width="54%"
        center>
      <div class="dialog-content">
        <div class="data-content">
          <div class="info-col-div"><span class="white-co">{{
              $t('DataSubmission.Satellite')
            }}:</span>&emsp;{{ sateDialogDetail.satelliteName }}
          </div>
        </div>
        <div class="data-content">
          <div class="info-col-div" :title="sateDialogDetail.sensorName"><span
              class="white-co">{{ $t('Order.Sensorname') }}:</span>&emsp;{{ sateDialogDetail.sensorName }}
          </div>
          <div class="info-col-div" :title="sateDialogDetail.productName"><span
              class="white-co">{{ $t('DataSubmission.ProductName') }}:</span>&emsp;{{ sateDialogDetail.productName }}
          </div>
          <div class="info-col-div" :title="sateDialogDetail.productFileName"><span
              class="white-co">{{ $t('Order.DataNo') }}:</span>&emsp;{{ sateDialogDetail.productFileName }}
          </div>
        </div>
        <div class="data-content">
          <div class="info-col-div" :title="sateDialogDetail.fileSize"><span
              class="white-co">{{ $t('product.FileSize') }}:</span>&emsp;{{ byte2Auto(sateDialogDetail.fileSize) }}
          </div>

          <div class="info-col-div" :title="sateDialogDetail.fileSuffix"><span
              class="white-co">{{ $t('Order.fileformat') }}:</span>&emsp;{{ sateDialogDetail.fileSuffix }}
          </div>
          <div class="info-col-div" :title="sateDialogDetail.creationDate"><span
              class="white-co">{{ $t('Order.Datagenerationtime') }}:</span>&emsp;{{ sateDialogDetail.creationDate }}
          </div>
        </div>
        <div class="data-content">
          <div class="info-col-div" :title="sateDialogDetail.createTime"><span
              class="white-co">{{ $t('Order.Shoppingcartaddtime') }}:</span>&emsp;{{ sateDialogDetail.createTime }}
          </div>

          <div class="info-col-div" :title="sateDialogDetail.stopTime"><span
              class="white-co">{{ $t('Order.Shootingtime') }}:</span>&emsp;{{ sateDialogDetail.stopTime }}
          </div>
          <div class="info-col-div"></div>
        </div>
        <div class="data-content">
          <div class="info-col-div">
            <el-image style="width: 300px;height: 300px" :src="sateDialogDetail.mediaUrl"></el-image>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :title="$t('Order.Productdatadetails')"
        :visible.sync="ProductOrderDetail"
        :custom-class="themeStatis==='theme1'?'dialog-new-bg-b':'dialog-new-bg-w'"
        width="50%"
        center>
      <div class="dialog-content">
        <div class="data-content">
          <div class="info-col-div"><span class="white-co">{{
              $t('DataSubmission.ProductName')
            }}:</span>&emsp;{{ productDialogDetail.productName }}
          </div>
        </div>
        <div class="data-content">
          <div class="info-col-div"><span class="white-co">{{
              $t('Order.Productdocumentname')
            }}:</span>&emsp;{{ productDialogDetail.productFileName }}
          </div>
          <div class="info-col-div"><span class="white-co">{{
              $t('product.FileSize')
            }}:</span>&emsp;{{ productDialogDetail.fileSize }}
          </div>
          <div class="info-col-div"><span class="white-co">{{
              $t('Order.fileformat')
            }}:</span>&emsp;{{ productDialogDetail.fileSuffix }}
          </div>
        </div>
        <div class="data-content">
          <div class="info-col-div"><span class="white-co">{{
              $t('Order.Shoppingcartaddtime')
            }}:</span>&emsp;{{ productDialogDetail.createTime }}
          </div>

          <div class="info-col-div"><span class="white-co">{{
              $t('Order.Datagenerationtime')
            }}:</span>&emsp;{{ productDialogDetail.creationDate }}
          </div>
          <div class="info-col-div"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import {
  getShopCarList,
  deleteShopCarSite,
  getOrderTypeFromShopCar,
  clearShopCarData,
  addAllToOrder
} from "@/api/shopCar/index"
import {createOneOrder} from "@/api/Order/index"
import {mapGetters} from "vuex";

export default {
  name: 'Shop',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      returnAll: '0.00KB',
      ProductOrderDetail: false,
      satelliteOrderDetail: false,
      orderType: [],
      total: 0,
      queryForm: {
        productName: '',
        fileName: '',
        carType: '',
        date: [],
        creationdStartDate: '',
        creationdEndDate: '',
        page: 1,
        limit: 20
      },
      hadSelectRow: [],
      submitForm: {
        username: '',
        Id: '',
        dataUsage: '',
        agree: false,
        carIds: []
      },
      username: '',
      userId: '',
      orderDetail: false,
      tableData: [],
      sateDialogDetail: {},
      productDialogDetail: {},
      showLoading: false,
      isEnglish: false
    }
  },
  methods: {
    /**
     * @description: 一键生成订单
     * @brief:
     * @Author: chenwei
     * @Date: 2022-07-08 19:13:31
     * @return {*}
     */
    async putAllToOrder() {
      let res = await addAllToOrder()
      console.log(res);
      this.$router.push('/order')
    },
    changeCarType(val) {
      console.log(val);
      this.getDatas()
    },
    viewDetail(val) {
      if (val.carTypeName === '卫星数据' || val.carTypeName === 'satelite') {
        this.satelliteOrderDetail = true
        this.sateDialogDetail = val
        this.sateDialogDetail.creationDate = this.sateDialogDetail.creationDate.split(' ')[0]
        this.sateDialogDetail.stopTime = this.sateDialogDetail.stopTime.split(' ')[0]
      } else {
        this.ProductOrderDetail = true
        this.productDialogDetail = val
        this.productDialogDetail.creationDate = this.productDialogDetail.creationDate.split(' ')[0]
      }

    },
    selectionChange(val) {
      console.log(val);
      this.hadSelectRow = val
      var a = 0
      val.forEach(element => {
        a = a + parseFloat(element.fileSize)
      });
      this.returnAll = this.byte2Auto(a)
    },
    createOrder() {
      if (this.hadSelectRow.length === 0) {
        this.$message({
          message: this.isEnglish ? 'Please select at least one piece of data' : '请至少选择一条数据',
          type: 'warning'
        });
        return
      } else {
        this.addOrder()
      }
      this.orderDetail = true
    },
    deleteThis(val) {
      this.$confirm(this.isEnglish ? 'Whether you want to delete it' : '是否确认要删除?', this.isEnglish ? 'Tips' : '提示', {
        confirmButtonText: this.isEnglish ? 'confirm' : '确定',
        cancelButtonText: this.isEnglish ? 'cancel' : '取消',
        type: 'warning'
      })
          .then(async () => {
            this.deleteOne(val)
            this.$message({
              type: 'success',
              message: this.isEnglish ? 'successfully delete' : '删除成功'
            })
            this.$store.dispatch('getShopTotal')
          }).catch(() => {
        this.$message({
          type: 'info',
          message: this.isEnglish ? 'The deletion has been cancelled' : '已取消删除'
        })
      })
    },
    async clearSelect() {
      console.info(this.hadSelectRow);
      if (this.hadSelectRow.length === 0) {
        this.$message({
          message: this.isEnglish ? 'Please select at least one piece of data' : '请至少选择一条数据',
          type: 'warning'
        });
        return
      }
      this.$confirm(this.isEnglish ? 'Confirm that you want to delete the selected data' : '是否确认要删除所选数据?', this.isEnglish ? 'Tips' : '提示', {
        confirmButtonText: this.isEnglish ? 'confirm' : '确定',
        cancelButtonText: this.isEnglish ? 'cancel' : '取消',
        type: 'warning'
      })
          .then(async () => {
            let params = [];
            this.hadSelectRow.forEach(element => {
              params.push(element.pkid)
            })
            let {data} = await deleteShopCarSite(params)
            let res = data
            console.log(res);
            this.$message({
              type: 'success',
              message: this.isEnglish ? 'successfully delete' : '删除成功'
            })
            this.getDatas()
            this.$refs.multipleTable.clearSelection();
            this.$store.dispatch('getShopTotal')
          }).catch(() => {
        this.$message({
          type: 'info',
          message: this.isEnglish ? 'canceled' : '已取消'
        })
      })
    },
    clearShopCar() {
      this.$confirm(this.isEnglish ? 'Confirm that you want to empty the shopping cart' : '是否确认要清空购物车?', this.isEnglish ? 'Tips' : '提示', {
        confirmButtonText: this.isEnglish ? 'confirm' : '确定',
        cancelButtonText: this.isEnglish ? 'cancel' : '取消',
        type: 'warning'
      })
          .then(async () => {
            let {data} = await clearShopCarData()
            let res = data
            console.log(res);
            this.getDatas()
            this.$message({
              type: 'success',
              message: this.isEnglish ? 'Empty the success' : '清空成功'
            })
            this.$store.dispatch('getShopTotal')
          }).catch(() => {
        this.$message({
          type: 'info',
          message: this.isEnglish ? 'canceled' : '已取消'
        })
      })
    },
    currentChange(val) {
      this.queryForm.page = val
      this.getDatas()
    },
    queryData() {
      let that = this
      this.$refs.queryForm.validate((valid) => {
        if (valid) {
          if (that.queryForm.date && that.queryForm.date.length != 0) {
            that.queryForm.creationdStartDate = that.queryForm.date[0] + ' 00:00:00'
            that.queryForm.creationdEndDate = that.queryForm.date[1] + ' 23:59:59'
          } else {
            this.queryForm.creationdStartDate = ''
            this.queryForm.creationdEndDate = ''
          }
          this.getDatas()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async addOrder() {
      this.showLoading = true
      let that = this
      let pkidList = [];
      this.hadSelectRow.forEach(element => {
        pkidList.push(element.pkid)
      })
      let parmas = JSON.parse(JSON.stringify(this.submitForm))
      parmas.carIds = pkidList
      let {data} = await createOneOrder(parmas)
      let res = data
      console.log(res);
      that.$message({
        type: 'success',
        message: this.isEnglish ? 'Order generation succeeded' : '订单生成成功'
      })
      if (res) {
        that.showLoading = false
      }
      that.orderDetail = false
      that.$store.dispatch('getShopTotal')
      that.$router.push('/order')
    },
    resetQuery() {
      this.queryForm.creationdStartDate = ''
      this.queryForm.creationdEndDate = ''
      this.$refs.queryForm.resetFields()
      this.getDatas()
    },
    async getDatas() {
      let parmas = JSON.parse(JSON.stringify(this.queryForm))
      delete parmas.date
      let {data} = await getShopCarList(parmas)
      let res = data
      this.tableData = res.list
      this.total = parseInt(res.totalCount)
    },
    async deleteOne(val) {
      let that = this
      let parmas = [val]
      let {data} = await deleteShopCarSite(parmas)
      let res = data
      console.log(res);
      this.getDatas()
      that.$store.dispatch('getShopTotal')
    },
    async getOrderType() {
      let that = this
      let {data} = await getOrderTypeFromShopCar({code: 'CAR_TYPE'})
      let res = data
      console.log(res)
      let a = [{
        dicItemName: this.isEnglish ? 'all data' : '所有数据',
        pkid: ''
      }]
      that.orderType = [...a, ...res]
      that.getDatas()
    }
  },
  computed: {
    ...mapGetters(['header_cell_style_bd', 'cell_style_bd', 'themeStatis']),
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
  created() {
    this.getOrderType()
  }
}
</script>

<style lang="scss" scoped>
.white-co {
  @include product_upload_label_co();
}

hr {
  @include hr_white_to_black();
}

.current-loc {
  height: 21px;
  display: flex;
  align-items: center;
  margin-top: 60px;

  /deep/ span {
    font-size: 15px;
    @include co_white_to_black();
  }

  /deep/ a {
    @include co_white_to_black();
  }

  /deep/ .el-breadcrumb__item:last-child {
    span {
      color: rgba(38, 125, 255, 1);
    }
  }
}

.Shop {
  width: 100%;
  @include table_page_bg();
  @include co_white_to_black();

  .content {
    min-height: 659px;
    width: 1551px;
    margin: 0 auto;

    .label {
      margin: 60px 0 20px 0;
    }

    .title {
      font-size: 28px;
      color: rgba(39, 121, 202, 1);
      margin: 20px 0;
    }

    .query {
      display: flex;
      align-items: center;
      font-size: 15px;
      margin: 20px 0;

      .query-item {
        display: flex;
        align-items: center;
        height: 40px;
        margin-right: 24px;

        /deep/ .el-form-item__label {
          @include co_white_to_black();
        }
      }
    }

    .data-table {
      margin: 20px 0;
      // height: 400px;
      .order-status1 {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        background: green;
        margin-right: 8px
      }

      .order-status2 {
        @extend .order-status1;
        background: rgba(24, 144, 255, 1);
      }

      .order-status3 {
        @extend .order-status1;
        background: rgba(24, 144, 255, 1);
      }

      .order-status {
      }

      .delete-detail {
        color: rgba(24, 144, 255, 1);
        margin: 0 8px;
        cursor: pointer;
      }
    }

    .pagenation {
      display: flex;
      justify-content: space-between;
      padding-right: 0;
      margin: 20px 0;

      &-left {
        display: flex;
        align-items: center;

        .select-nums {
          font-size: 15px;
          margin-right: 12px;
          padding: 0 24px;
          height: 34px;
          border-radius: 3px;
          border: 1px solid rgba(186, 231, 255, 1);
          background-color: rgba(186, 231, 255, 0.3);
          display: flex;
          align-items: center;

          svg {
            margin: 2px 8px 0 0;
          }

          .totals {
            margin-left: 12px;
          }

          .nums {
            color: rgba(24, 144, 255, 1);
          }
        }
      }
    }
  }

  .order-detail {
    width: 100%;

    /deep/ .el-form-item__content {
      line-height: 0;
    }

    ::v-deep .el-form-item:nth-child(4) {
      margin-bottom: 12px;
    }
  }

  ::v-deep .btn-next {
    margin-right: 0;
  }

  ::v-deep .el-pagination {
    padding-right: 0;
  }
}

/deep/ .el-table-column--selection {
  .cell {
    padding: 0 10px;
  }
}

/deep/ .el-form-item__label {
  @include product_upload_label_co();
}

/deep/ .el-dialog, .el-pager li {
  @include shop_dialog_bg();
}

/deep/ .el-dialog__title {
  @include product_upload_label_co();
}

.dialog-content {
  display: flex;
  flex-direction: column;

  .data-content {
    display: flex;
    margin-bottom: 20px;
    flex-direction: row;
    justify-content: space-around;

    .info-col-div {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .info-col-div3 {
      width: 45%;
    }
  }
}

/deep/ .basic-info-detail .el-dialog__header {
  padding: 12px 30px !important;

  span {
    font-size: 15px;
  }

  .el-dialog__headerbtn {
    margin-top: -4px;
  }
}

/deep/ .dialog-new-bg-w {
  background: white;

  .el-form-item__label {
    color: black
  }

  .el-dialog, .el-pager li {
    background: white

  }

  .el-dialog__title {
    color: black
  }
}

/deep/ .dialog-new-bg-b {
  background: rgb(29, 29, 29);

  .el-form-item__label {
    color: white;
  }

  .el-dialog, .el-pager li {
    background: rgb(29, 29, 29)

  }

  .el-dialog__title {
    color: white;
  }
}
</style>